import { render, staticRenderFns } from "./ThangPN.vue?vue&type=template&id=5881a861&scoped=true"
import script from "./ThangPN.vue?vue&type=script&lang=js"
export * from "./ThangPN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881a861",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5881a861')) {
      api.createRecord('5881a861', component.options)
    } else {
      api.reload('5881a861', component.options)
    }
    module.hot.accept("./ThangPN.vue?vue&type=template&id=5881a861&scoped=true", function () {
      api.rerender('5881a861', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/ThangPN.vue"
export default component.exports